<form (ngSubmit)="login()">
    <label for="password">Password:</label>
    <input type="password" id="password" [(ngModel)]="password" name="password" required>
    <br>
    <button type="submit">Login</button>
</form>